
import { Component, Prop, Vue } from 'vue-property-decorator';
import JsonEditor from '@/components/shared/forms/JsonEditor.vue';
import { IpdcProduct, IpdcProductTheme } from '@govflanders/mbp-admin-panel-shared';
import { Getter } from 'vuex-class';
import { getProductSchema } from '@/utility/ipdc';

@Component({
  components: {
    JsonEditor,
  },
})
export default class ProductForm extends Vue {
  public schema: object;

  @Prop({
    type: Object,
    required: false,
  })
  public value: IpdcProduct;

  public themeObject = {
    code: '',
    name: '',
  };

  @Getter('ipdcProduct/themeOptions')
  public themeOptions: IpdcProductTheme[];

  public async created() {
    this.schema = getProductSchema();
    await this.$store.dispatch('ipdcProduct/getThemeOptions');
  }

  public get themeCode() {
    if (this.value.mbpTheme) {
      return this.value.mbpTheme.code;
    }
    return '';
  }

  public get currentValue(): IpdcProduct {
    return this.value;
  }

  public clearTheme() {
    this.value.mbpTheme = null;
    this.$emit('input', this.value);
  }

  public updateTheme(themeValue: string) {
    this.value.mbpTheme = this.themeOptions.find(
      (option: IpdcProductTheme) => option.code === themeValue,
    );
    this.$emit('input', this.value);
  }
}
